import { Modal, Box, IconButton } from '@mui/material';
import { CloseRounded } from '@mui/icons-material';
import {
  ActionButtons,
  IActionButton,
} from '../components/atoms/actionButtons';

interface ModalProps {
  title: JSX.Element;
  content: JSX.Element;
  secondaryAction?: JSX.Element;
  isOpen: boolean;
  onClose: () => void;
  items?: IActionButton[];
  fullWidth?: boolean;
}

const ModalTemplate = (props: ModalProps) => {
  const { title, content, secondaryAction, isOpen, onClose, items, fullWidth } =
    props;

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      sx={(theme) => ({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // Ensure the backdrop sits above any fixed/sticky app headers.
        zIndex: theme.zIndex.modal + 2,
      })}
    >
      <Box
        sx={{
          // Desktop behavior: prefers ~44vw, capped at 760px, never smaller than 560px.
          // Mobile behavior: maxWidth forces it down to (100vw - 32px), i.e. almost full width.
          width: fullWidth ? '90%' : 'clamp(560px, 44vw, 1024px)',
          maxWidth: 'calc(100vw - 32px)',
          bgcolor: 'background.paper',
          borderRadius: 1,
          boxShadow: 24,
          m: 0,
          maxHeight: 'calc(100vh - 68px)',
          overflow: 'auto',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            p: { xs: 1, md: 2 },
          }}
        >
          <>{title}</>
          <IconButton
            aria-label='close-modal'
            onClick={onClose}
            sx={{ color: 'primary.main', p: 0, m: 0 }}
          >
            <CloseRounded />
          </IconButton>
        </Box>

        <Box pb={1} px={{ xs: 1, md: 2 }}>
          <>{content}</>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            {secondaryAction}
          </Box>

          {items && <ActionButtons items={items} />}
        </Box>
      </Box>
    </Modal>
  );
};

ModalTemplate.defaultProps = {
  secondaryAction: undefined,
  items: undefined,
  fullWidth: false,
};

export default ModalTemplate;
